// src/components/Footer.tsx
import React from "react";
import "./Footer.css";

export const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p className="copyright">
          © {new Date().getFullYear()} Expanded Chess. All Rights Reserved.
        </p>
        <div className="footer-links">
          <a href="/terms" className="footer-link">
            Terms of Service
          </a>
          <span className="footer-separator">|</span>
          <a href="/privacy" className="footer-link">
            Privacy Policy
          </a>
          <span className="footer-separator">|</span>
          <a href="/contact" className="footer-link">
            Contact Us
          </a>
        </div>
        <p className="footer-tagline">
          36 Unique Pieces • 6 Classes • Multiple Board Sizes • Endless
          Possibilities
        </p>
      </div>
    </footer>
  );
};

export default Footer;
